import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import JobList from "./components/JobList";
import JobDetail from "./components/JobDetail";
import AddJob from "./components/AddJob";

const App = () => {
    const [jobs, setJobs] = useState([]);
  
    useEffect(() => {
      fetch("https://api.hireeco.in/api/jobs")
        .then((response) => response.json())
        .then((data) => setJobs(data))
        .catch((error) => console.error("Error fetching jobs:", error));
    }, []);
  
  
//const App = () => (
return (
    <Router>
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
                <div className="container">
                    <Link className="navbar-brand" to="/">Job Portal</Link>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <Link className="nav-link" to="/">Home</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>


        <Routes>
            <Route path="/" element={<JobList />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/add-job" element={<AddJob />} />
        </Routes>
    </div>
    </Router>
);
};

export default App;
